// Format to locale string and remove decimals, e.g. 1234.56 => 1,235
export default function formatAndDropDecimal(v: number): string {
  return v.toLocaleString(undefined, { maximumFractionDigits: 0 });
}
